import fsm_cov from "../../../../src/sv/images/fsm_coverage.svg";
import * as React from 'react';
export default {
  fsm_cov,
  React
};